import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { useQuery } from '@apollo/client'

import { GQL_QUERY_SEARCH_PRODUCTS_WITH_FILTER } from '@@partner:graphql/query/product/searchProductsWithFilter.gql'

export default function useProductSearch (
  shop_id?: GQL_ID,
  filter: any = {},
  limit: number = 6
) {
  const { data, loading, error, fetchMore } = useQuery(
    GQL_QUERY_SEARCH_PRODUCTS_WITH_FILTER,
    {
      variables: {
        filter,
        shop_id,
        limit
      },
      skip: !shop_id
    }
  )

  const products: Product[] = data?.searchProducts?.edges ?? []

  return {
    products,
    data,
    loading,
    error,
    fetchMore
  }
}
